import { render, staticRenderFns } from "./nodalView.vue?vue&type=template&id=0a108e41"
import script from "./nodalView.vue?vue&type=script&lang=js"
export * from "./nodalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports